import React from "react";
import { Link } from "react-router-dom";

const Success = () => {
  return (
    <div className="wrapper_payment_status">
      <div className="wrap_card_payment">
        <h1>🎉</h1>
        <h1>Payment Successful </h1>
        <p>Thank you for your subscription!</p>
        <Link to="/" className="button text-center mt-5 ">
          Home
        </Link>
      </div>
    </div>
  );
};

export default Success;
